import { useEffect, useState } from 'react';

export default function AllServicesHero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  const scrollToBook = () => {
    const el = document.getElementById('book');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToContent = () => {
    const el = document.getElementById('all-services-content');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/8a6d54eeac3ee302218979631d304cd6.jpg"
          alt="All Studio Services"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-950/95 via-stone-950/75 to-stone-950/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-stone-950/80 via-transparent to-stone-950/30" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-28 pb-24">
        <div className="max-w-3xl">
          <div
            className={`inline-flex items-center gap-2.5 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs font-bold uppercase tracking-widest px-5 py-2.5 rounded-full mb-8 transition-all duration-700 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400" />
            </span>
            Available Today — Book Instantly
          </div>

          <h1
            className={`font-serif text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-white leading-[1.04] mb-7 transition-all duration-700 delay-100 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            Our Studio Services
          </h1>

          <p
            className={`text-stone-300 text-xl md:text-2xl leading-relaxed mb-10 max-w-2xl transition-all duration-700 delay-200 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            Photography studios, video production rooms, podcast booths, content creation spaces, and event venues — all fully equipped and available for instant booking.
          </p>

          <div
            className={`flex flex-wrap items-center gap-4 mb-10 transition-all duration-700 delay-300 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            <button
              onClick={scrollToBook}
              className="group bg-amber-500 hover:bg-amber-600 text-white font-bold px-10 py-5 rounded-xl text-lg transition-all cursor-pointer whitespace-nowrap flex items-center gap-2.5"
            >
              Book Your Studio
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={scrollToContent}
              className="flex items-center gap-2.5 text-white/90 hover:text-white border border-white/30 hover:border-white/70 font-semibold px-10 py-5 rounded-xl text-lg transition-all cursor-pointer whitespace-nowrap backdrop-blur-sm"
            >
              Explore All Services
            </button>
          </div>

          <div
            className={`flex items-center gap-5 transition-all duration-700 delay-400 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            <div className="flex items-center gap-2">
              <div className="flex">
                {[1, 2, 3, 4, 5].map((s) => (
                  <i key={s} className="ri-star-fill text-amber-400 text-sm" />
                ))}
              </div>
              <span className="text-white font-semibold text-sm">4.9</span>
              <span className="text-white/50 text-sm">(840+ reviews)</span>
            </div>
            <div className="w-px h-5 bg-white/20" />
            <a
              href="tel:+18005551234"
              className="flex items-center gap-2 text-sm text-white/70 hover:text-amber-400 transition-colors cursor-pointer"
            >
              <i className="ri-phone-fill text-amber-400" />
              (800) 555-1234
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 bg-black/40 backdrop-blur-md border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 grid grid-cols-4 gap-4">
          {[
            { value: '5', label: 'Studio Types' },
            { value: '50+', label: 'Studio Spaces' },
            { value: '6', label: 'Major Cities' },
            { value: '4.9★', label: 'Avg. Rating' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-white font-bold text-xl md:text-2xl font-serif leading-none">{stat.value}</div>
              <div className="text-white/45 text-[11px] mt-1 uppercase tracking-wide">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
